module.exports = __webpack_public_path__ + "static/media/45.b211ca0b.png";